import { UseMutationResult, useMutation, useQuery } from 'react-query';
import { DependenciesMap, ProjectSourceType } from 'api/project';
import {
  DependenciesMapGenerationPayload,
  TemplateState,
  TemplatesAPI,
} from 'data/templates/api';
import { ProjectTemplateApi } from 'data/templates/projects';
import { ProjectTemplatesAPI } from 'data/templates/projects/api';
import { oneDay } from '../constants';

export const PROJECT_TEMPLATE_OPTIONS_QUERY_KEY =
  'PROJECT_TEMPLATE_OPTIONS_QUERY_KEY';

export interface ProjectTemplateOption
  extends Pick<ProjectTemplateApi, 'state'> {
  label: string;
  value: number;
  sourceType: ProjectSourceType.Template;
  sourceId: number;
}

const usePublishedProjectTemplateOptionsQuery = () => {
  return useQuery<ProjectTemplateApi[], unknown, ProjectTemplateOption[]>(
    PROJECT_TEMPLATE_OPTIONS_QUERY_KEY,
    () => {
      return ProjectTemplatesAPI.getAllTemplates();
    },
    {
      staleTime: oneDay,
      refetchOnWindowFocus: false,
      select: (data) => {
        return data
          .filter(({ state }) => state === TemplateState.Published)
          .map(
            ({ templateId, templateName, state }): ProjectTemplateOption => ({
              label: templateName ?? '',
              value: templateId as number,
              sourceType: ProjectSourceType.Template,
              sourceId: templateId as number,
              state,
            }),
          );
      },
    },
  );
};

const useGetTemplateDependenciesMap = (): UseMutationResult<
  DependenciesMap,
  unknown,
  DependenciesMapGenerationPayload,
  unknown
> => {
  return useMutation((payload: DependenciesMapGenerationPayload) =>
    TemplatesAPI.getTemplateDependenciesMap(payload),
  );
};

export {
  usePublishedProjectTemplateOptionsQuery,
  useGetTemplateDependenciesMap,
};
